// extracted by mini-css-extract-plugin
export default {"searchUser":"styles_searchUser__zp-fT","searchInput":"styles_searchInput__ZSzVu"};